/* eslint-disable @typescript-eslint/ban-types */
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useStyles } from './UserProfileStyles'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { activateUserData, fetchUsersData } from '../../actions'

export default function ActivateUserAccount({ userId, open, onClose, userDetails }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)

  useEffect(() => {
    dispatch(fetchUsersData())
  }, [])

  const updateView = () => {
    onClose(false)
    setOpenSuccessSnackBar(true)
  }

  const handleActivateUserAccount = (event, userId, activateUserId) => {
    dispatch(
      activateUserData({
        userId: userId,
        activateUserId: activateUserId,
      }),
    )
    setTimeout(updateView, 1500)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && <SuccessSnackBar message="Successfully activated the user account" />}
      {openErrorSnackBar && <ErrorSnackBar message="Activation of user account failed" />}
      <Dialog
        fullWidth
        maxWidth="sm"
        id="hello"
        classes={{ paper: classes.dialogHeight }}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>Activate User Account</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            Are you sure you want to activate this user account?
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={(event) => handleActivateUserAccount(event, userId, userDetails?.id)}
            endIcon={<CheckIcon />}
          >
            Yes
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
